// For full API documentation, including code examples, visit https://wix.to/94BuAAs
import wixWindow from 'wix-window';

$w.onReady(function () {
 if(wixWindow.formFactor === "Mobile"){
  $w("#image16").show();
  $w("#image17").show();        
 }
});